<template>
  <NewHouseLayout :breadcrumbs="[{ name: '选择业务' }]">
    <div class="nh-page">
    <div class="nh-card">
      <div class="nh-section-title">
        <span class="bar"></span>选择要办理的业务（可多选）
        <el-checkbox
          v-if="businessList.length"
          class="nh-select-all"
          :model-value="allSelected"
          :indeterminate="halfSelected"
          @change="toggleAll"
        >
          {{ allSelected ? '取消全选' : '全选' }}
        </el-checkbox>
      </div>

      <ul class="nh-business-list">
        <li
          v-for="b in businessList"
          :key="b.key"
          class="nh-business-item"
          @click="toggle(b.key)"
        >
          <el-checkbox
            :model-value="selected.includes(b.key)"
            @change="toggle(b.key)"
            size="large"
          />
          <div class="nh-business-content">
            <div class="nh-business-name">{{ b.name }}</div>
          </div>
          <div class="nh-business-desc">{{ b.desc }}</div>
        </li>
      </ul>
    </div>

    <div class="nh-footer">
      <el-button
        size="large"
        class="nh-btn nh-btn-prev"
        @click="handlePrev"
      >
        上一步
      </el-button>
      <el-button
        type="danger"
        size="large"
        class="nh-btn nh-btn-next"
        :disabled="!selected.length"
        @click="handleNext"
      >
        下一步
      </el-button>
    </div>
  </div>
  </NewHouseLayout>
</template>

<script setup>
import NewHouseLayout from './layout.vue';
import { ref, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { getTodoListRe } from '@/api/newHouse';
import { decodeData } from '@/utils/decodeData';

const router = useRouter();

const selected = ref([]);
const businessList = ref([]);

const allSelected = computed(
  () =>
    businessList.value.length > 0 &&
    selected.value.length === businessList.value.length
);
const halfSelected = computed(
  () => selected.value.length > 0 && !allSelected.value
);

// 加载待办事项列表
const fetchTodoList = async () => {
  try {
    const res = await getTodoListRe();
    // res 是 axios 完整 response，res.data 是后端 {code, msg, data}
    // 后端 data 是 URL 编码 + JSON 字符串，decodeData 把它解析成业务数组
    const data = res?.data;
    const list = decodeData(data);
    const arr = Array.isArray(list) ? list : (list?.data || []);
    businessList.value = arr.map((it) => ({
      key: it.id,
      name: it.title,
      desc: it.title1,
    }));
  } catch (e) {
    businessList.value = [];
  }
};

onMounted(() => {
  fetchTodoList();
});

const toggle = (key) => {
  const idx = selected.value.indexOf(key);
  if (idx >= 0) {
    selected.value.splice(idx, 1);
  } else {
    selected.value.push(key);
  }
};

const toggleAll = () => {
  if (allSelected.value) {
    selected.value = [];
  } else {
    selected.value = businessList.value.map((b) => b.key);
  }
};

const handlePrev = () => {
  router.push({ name: 'newHouseMyList' });
};

// 下一步：跳转到选房页（业务创建在选完房后调 ywcj）
const handleNext = () => {
  if (!selected.value.length) return;
  router.push({
    name: 'newHouseSelectHouse',
    query: { biz: selected.value.join(',') },
  });
};
</script>

<style lang="scss" scoped>
.nh-page {
  background: #ffffff;
  padding: 16px 0 24px;
  box-sizing: border-box;
}

.nh-card {
  max-width: 960px;
  margin: 0 auto;
  background: #ffffff;
}

.nh-section-title {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 16px;
  text-align: left;

  .bar {
    display: inline-block;
    width: 4px;
    height: 18px;
    background: #bd1a2d;
    border-radius: 2px;
    margin-right: 10px;
  }
}

.nh-select-all {
  margin-left: auto;
  font-size: 14px;
  font-weight: normal;
  color: #606266;
}

.nh-business-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.nh-business-item {
  display: flex;
  align-items: center;
  padding: 20px 0;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  text-align: left;

  &:last-child {
    border-bottom: none;
  }
}

.nh-business-content {
  flex: 0 0 320px;
  padding-left: 8px;
}

.nh-business-name {
  font-size: 16px;
  color: #2c3e50;
  font-weight: 500;
}

.nh-business-desc {
  flex: 1;
  font-size: 14px;
  color: #888;
  padding-left: 24px;
}

.nh-footer {
  max-width: 1200px;
  margin: 24px auto 0;
  background: #ffffff;
  padding: 16px;
  display: flex;
  justify-content: center;
  gap: 24px;
  border-radius: 6px;
}

.nh-btn {
  width: 200px;
  height: 44px;
  font-size: 16px;
}

.nh-btn-prev {
  background: #fdecec;
  color: #bd1a2d;
  border-color: #fdecec;
}

.nh-btn-next {
  background: #bd1a2d;
  border-color: #bd1a2d;
}
</style>
